import React from "react";
import { Paper, Stack, Typography, Box, Button, Chip } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddIcon from "@mui/icons-material/Add";

import TaskList from "../Clinical/TaskList";

/**
 * Panel "My Tasks" del Employee Dashboard.
 * Reutiliza TaskList (agrupa por Overdue / Due Today / Upcoming / Completed)
 * y expone el botón para crear una nueva tarea.
 */
export default function EmployeeTasksPanel({
  tasks,
  loading,
  onComplete,
  onCancel,
  onDelete,
  onEdit,
  onNewTask,
}) {
  const activeCount = (tasks || []).filter(
    (t) => t.status !== "completed" && t.status !== "cancelled"
  ).length;

  return (
    <Paper
      elevation={0}
      sx={{ p: 2.5, borderRadius: 3, border: "1px solid", borderColor: "divider", height: "100%" }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                borderRadius: 1.5,
                bgcolor: "#EFF6FF",
                color: "#2563EB",
              }}
            >
              <AssignmentIcon sx={{ fontSize: 16 }} />
            </Box>
            <Typography variant="subtitle2" fontWeight={700}>
              My Tasks
            </Typography>
            {!loading && (
              <Chip
                label={`${activeCount} active`}
                size="small"
                sx={{ height: 22, fontSize: "0.7rem", fontWeight: 600, bgcolor: "#F1F5F9", color: "#475569" }}
              />
            )}
          </Stack>
          <Button
            size="small"
            variant="contained"
            startIcon={<AddIcon sx={{ fontSize: 14 }} />}
            onClick={onNewTask}
            sx={{ textTransform: "none", fontSize: "0.72rem", borderRadius: 2 }}
          >
            New Task
          </Button>
        </Stack>

        {/* Task List */}
        <TaskList
          tasks={tasks}
          loading={loading}
          onComplete={onComplete}
          onCancel={onCancel}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      </Stack>
    </Paper>
  );
}
